"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var moment = require("moment");
var validators_1 = require("../../validators");
var selectable_item_view_model_1 = require("./../../item-selector/selectable-item-view.model");
var PolicyItemViewModel = (function (_super) {
    __extends(PolicyItemViewModel, _super);
    function PolicyItemViewModel(packageName, policyNumber, status) {
        var _this = _super.call(this) || this;
        _this._packageName = packageName;
        _this._policyNumber = policyNumber;
        _this._status = status;
        _this.updateValues();
        return _this;
    }
    Object.defineProperty(PolicyItemViewModel.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (v) {
            this._status = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyItemViewModel.prototype, "value", {
        get: function () {
            return this._packageName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyItemViewModel.prototype, "packageName", {
        set: function (v) {
            this._packageName = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyItemViewModel.prototype, "policyNumber", {
        get: function () {
            return this._policyNumber;
        },
        set: function (v) {
            this._policyNumber = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyItemViewModel.prototype, "effectiveDate", {
        get: function () {
            return this._effectiveDate;
        },
        set: function (v) {
            this._effectiveDate = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolicyItemViewModel.prototype, "expirationDate", {
        get: function () {
            return this._expirationDate;
        },
        set: function (v) {
            this._expirationDate = v;
            this.updateValues();
        },
        enumerable: true,
        configurable: true
    });
    PolicyItemViewModel.fromPolicyClaimConfiguration = function (source) {
        var target = new PolicyItemViewModel(source.packageDisplayName, source.policyNumber, source.status);
        target.effectiveDate = source.effectiveDate;
        target.expirationDate = source.expirationDate;
        return target;
    };
    PolicyItemViewModel.prototype.updateValues = function () {
        this.preview = this.getPreview();
        this.title = this.getTitle();
        this.subTitle = this.getSubTitle();
        this.supplementalInformation = this.getSupplementalInformation();
    };
    PolicyItemViewModel.prototype.getPreview = function () {
        return "<b>" + this._packageName + ":</b> Policy #" + this._policyNumber + " " + this.getDisplayStatus(this._status);
    };
    PolicyItemViewModel.prototype.getTitle = function () {
        return this._packageName + " " + this.getDisplayStatus(this._status);
    };
    PolicyItemViewModel.prototype.getSubTitle = function () {
        return "Policy Number # <b>" + this._policyNumber + "</b>";
    };
    PolicyItemViewModel.prototype.getSupplementalInformation = function () {
        if (this._effectiveDate && this._expirationDate) {
            return this.getDisplayDate(this._effectiveDate) + " - " + this.getDisplayDate(this._expirationDate);
        }
        else {
            return null;
        }
    };
    PolicyItemViewModel.prototype.getDisplayDate = function (date) {
        var parseFormat = validators_1.Constants.DATE_PARSE_FORMAT + "THH:mmZ";
        var displayFormat = "" + validators_1.Constants.DATE_DISPLAY_FORMAT;
        return moment.utc(date, parseFormat).format(displayFormat);
    };
    PolicyItemViewModel.prototype.getDisplayStatus = function (status) {
        switch (status) {
            case 'Active':
                status = 'Upcoming';
                break;
            case 'Expired':
                status = 'Past';
                break;
            case 'Effective':
                status = 'Active';
                break;
            case 'Cancelled':
                status = 'Cancelled';
                break;
            case 'Future':
                status = 'Upcoming';
                break;
            default:
                status = null;
        }
        if (status) {
            status = "(" + status.toUpperCase() + ")";
        }
        return status;
    };
    return PolicyItemViewModel;
}(selectable_item_view_model_1.SelectableItemViewModel));
exports.PolicyItemViewModel = PolicyItemViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/claims/policy-item-view.model.js